import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getServiceTypes, getProviderService, addProviderService, updateProviderService, deleteProviderService } from "../slice/providerPanelServiceSlice";
import { getProviderStripePaymentStatus } from "../slice/providerStripePaymentSlice";
import { toast } from "react-toastify";
import QuillEditor from "./text_editor";

const ProviderPanelService = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { providersService: provider, loading, serviceTypes } = useSelector((state) => state.providerService);
  const { providerStripePaymentSetting } = useSelector((state) => state.providerStripePaymentSetting);
  const [sortConfig, setSortConfig] = useState({ column: null, direction: "asc" });

  const [showModal, setShowModal] = useState(false);
  const [modalMode, setModalMode] = useState("edit");
  const [selectedService, setSelectedService] = useState(null);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [serviceToDelete, setServiceToDelete] = useState(null);

  useEffect(() => {
  if (showModal) {
    document.body.classList.add("modal-open");
    document.body.style.overflow = "hidden";
  } else {
    document.body.classList.remove("modal-open");
    document.body.style.overflow = "";
  }

  return () => {
    // Cleanup on unmount
    document.body.classList.remove("modal-open");
    document.body.style.overflow = "";
  };
}, [showModal]);

useEffect(() => {
  if (!selectedService) return;
  if (!selectedService.service_description) {
    setSelectedService(prev => ({ ...prev, service_description: '' }));
  }
}, [selectedService]);

  useEffect(() => {
  if (selectedService) {
    setLanguages(
      Array.isArray(selectedService.language_support)
        ? selectedService.language_support.map(item => item.value)
        : []
    );

    setFields(
      Array.isArray(selectedService.additional_tags)
        ? selectedService.additional_tags.map(item => item.value)
        : []
    );
  } else {
    setLanguages([]);
    setFields([]);
  }
}, [selectedService]);



  const handleEditClick = (service) => {
    console.log("service", service);
    setSelectedService(service);
    setModalMode("edit");
    setShowModal(true);
  };
  
  const handleAddClick = () => {
    const isStripeFullySetUp =
    providerStripePaymentSetting?.charges_enabled &&
    providerStripePaymentSetting?.details_submitted &&
    providerStripePaymentSetting?.payouts_enabled;

  if (!isStripeFullySetUp) {
    toast.error("Please complete your Stripe setup to add services.", {
      position: "top-right",
      autoClose: 3000,
    });

    // Redirect after a short delay
    setTimeout(() => {
      navigate("/provider/panel/stripe-setting"); // change to your actual route
    }, 3000);

    return;
  }

    setSelectedService({
      service_type: "",
      service_name: "",
      duration: "",
      amount_per_session: "",
      from_age: "",
      to_age: "",
      meals: [],
      language_support: [],
      additional_tags: [],
      service_mode: [],
      service_description: "",
      duration_in_days: "",
      daily_hours: "",
      amount: "",
      charge_per_week: ""
    });
    setModalMode("add");
    setShowModal(true);
  };

  const handleChange = (e) => {
  const { name, value, type, checked } = e.target;

  // For checkboxes that might store arrays (like meals, language_support, etc.)
  if (type === "checkbox") {
    // Handle checkbox logic if the data is stored as array of selected items
    // Assuming the selectedService fields for checkboxes are arrays, e.g. meals: []
    const currentValues = selectedService[name] || [];

    let updatedValues;
    if (checked) {
      // Add the value if checked and not already included
      updatedValues = currentValues.includes(value)
        ? currentValues
        : [...currentValues, value];
    } else {
      // Remove the value if unchecked
      updatedValues = currentValues.filter((v) => v !== value);
    }

    setSelectedService({
      ...selectedService,
      [name]: updatedValues,
    });
  } else {
    // For normal inputs
    setSelectedService({
      ...selectedService,
      [name]: value,
    });
  }
};


  // Handle modal close
  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedService(null);
  };

  const token = localStorage.getItem("provider_access_token");

  useEffect(() => {
    dispatch(getProviderService(token));
    dispatch(getProviderStripePaymentStatus(token));
    dispatch(getServiceTypes());
  }, [dispatch, token]);

  console.log("providerStripePaymentSetting", providerStripePaymentSetting);

     const [languageInput, setLanguageInput] = useState("");
  const [languages, setLanguages] = useState([]);

  const [fieldInput, setFieldInput] = useState("");
  const [fields, setFields] = useState([]);

  // Helper to add tags from input to tag list
  const addTags = (value, tags, setTags) => {
    const newTags = value
      .split(",")
      .map(tag => tag.trim())
      .filter(tag => tag.length > 0 && !tags.includes(tag));
    if (newTags.length > 0) {
      setTags([...tags, ...newTags]);
    }
  };

  // Handles key down for either input
  const handleKeyDown = (e, inputValue, setInput, tags, setTags) => {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      addTags(inputValue, tags, setTags);
      setInput("");
    }
  };

  // Remove tag from specified list
  const removeTag = (indexToRemove, tags, setTags) => {
    setTags(tags.filter((_, i) => i !== indexToRemove));
  };
  // console.log("provider", provider);
  // console.log("serviceTypes", serviceTypes);

  const serviceList = provider?.service_type || [];

  const handleAddService = async () => {

    const { service_type, service_name, duration } = selectedService;

    if (!service_type || !service_name || !duration) {
      toast.error("Please fill all required fields.", {
        position: "top-right",
        autoClose: 2000,
        style: { fontSize: "0.85rem" },
      });
      return;
    }
    const servicePayload = {
    ...selectedService,
    language_support: languages.map(val => ({ value: val })),
    additional_tags: fields.map(val => ({ value: val }))
  };
  // Add your logic to add new service, e.g., dispatch an action or call an API
  const result = await dispatch(
    addProviderService({
      token,
      serviceData: servicePayload,
    })
  )
  if (result.meta.requestStatus === "fulfilled") {
    toast.success("Service Added successful!", {
      position: "top-right",
      autoClose: 2000,
      style: { fontSize: "0.85rem" },
    });

    dispatch(getProviderService(token));
    handleCloseModal();
  } else {
    toast.error("Failed to add service", {
      position: "top-right",
      autoClose: 2000,
      style: { fontSize: "0.85rem" },
    });
  }
};

  // Handle form submission (for saving changes)
  const handleSaveChanges = async () => {
    const { id, ...dataWithoutId } = selectedService;

    const updatedPayload = {
    ...dataWithoutId,
    language_support: languages.map(val => ({ value: val })),
    additional_tags: fields.map(val => ({ value: val })),
  };

    const result = await dispatch(
      updateProviderService({
        token,
        serviceId: id,
        serviceData: updatedPayload,
      })
    );

    if (result.meta.requestStatus === "fulfilled") {
      toast.success("Service updated successfully!", {
        position: "top-right",
        autoClose: 2000,
        style: { fontSize: "0.85rem" },
      });

      dispatch(getProviderService(token));
      handleCloseModal();
    } else {
      toast.error("Failed to update service", {
        position: "top-right",
        autoClose: 2000,
        style: { fontSize: "0.85rem" },
      });
    }
  };

  const handleDeleteClick = (service) => {
    setServiceToDelete(service);
    setConfirmDelete(true);
  };

  const confirmDeleteService = async () => {
    if (!serviceToDelete) return;
    const result = await dispatch(
      deleteProviderService({ token, serviceId: serviceToDelete.id })
    );

    if (result.meta.requestStatus === "fulfilled") {
      toast.success("Service deleted successfully", {
        position: "top-right",
        autoClose: 2000,
        style: { fontSize: "0.85rem" },
      });
      dispatch(getProviderService(token)); // Refresh list
    } else {
      toast.error("Failed to delete service", {
        position: "top-right",
        autoClose: 2000,
        style: { fontSize: "0.85rem" },
      });

    }

    setConfirmDelete(false);
    setServiceToDelete(null);
  };

  const sortedData = [...serviceList].sort((a, b) => {
      if (sortConfig.column === null) return 0;

      const key = sortConfig.column;

      const valA = a[key] ?? "";
      const valB = b[key] ?? "";

      if (!isNaN(valA) && !isNaN(valB)) {
         return sortConfig.direction === "asc"
            ? valA - valB
            : valB - valA;
      } else {
         return sortConfig.direction === "asc"
            ? valA.toString().localeCompare(valB.toString())
            : valB.toString().localeCompare(valA.toString());
      }
   });

   const handleSort = (columnKey) => {
      let direction = "asc";
      if (sortConfig.column === columnKey && sortConfig.direction === "asc") {
         direction = "desc";
      }
      setSortConfig({ column: columnKey, direction });
   };

   const addTagsToService = (inputValue, fieldName) => {
  const existing = selectedService[fieldName]?.map(tag => tag.value) || [];
  const newTags = inputValue
    .split(",")
    .map(tag => tag.trim())
    .filter(tag => tag.length > 0 && !existing.includes(tag));

  if (newTags.length > 0) {
    setSelectedService(prev => ({
      ...prev,
      [fieldName]: [...(prev[fieldName] || []), ...newTags.map(val => ({ value: val }))]
    }));
  }
};

const handleKeyDownServiceTag = (e, inputValue, setInput, fieldName) => {
  if (e.key === "Enter" || e.key === ",") {
    e.preventDefault();
    addTagsToService(inputValue, fieldName);
    setInput("");
  }
};


const removeServiceTag = (indexToRemove, fieldName) => {
  const updatedTags = selectedService[fieldName]?.filter((_, i) => i !== indexToRemove) || [];
  setSelectedService(prev => ({
    ...prev,
    [fieldName]: updatedTags
  }));
};


  return (
  <>
    <style>{`
      .modal-backdrop-custom {
          position: fixed;
          top: 0;
          left: 0;
          z-index: 1040;
          width: 100vw;
          height: 100vh;
          background-color: rgba(0, 0, 0, 0.5);
      }
    `}
    </style>

    {showModal && <div className="modal-backdrop-custom"></div>}
      <div className="col-md-8 col-xl-9 mt-4 mt-md-0">
        <div className="ps-2 ps-lg-4">
          <h4 className="font-weight-bold text-primary font-size-40 mb-4 pb-1 line-hight-2 border-bottom pb-3 montserrat d-flex">
          My Services
          <button className="btn btn-danger ms-auto py-2"  onClick={handleAddClick} >
            <i className="fa fa-user-plus me-1"></i> Add Services
          </button>
          </h4>

          {!(
  providerStripePaymentSetting?.charges_enabled &&
  providerStripePaymentSetting?.details_submitted &&
  providerStripePaymentSetting?.payouts_enabled
) && (
  <div className="mb-3">
    <h5 className="mb-2">Stripe Setup Progress:</h5>
    <ul className="list-unstyled">
      <li>
        1. Charges Enabled:{" "}
        <span
          className={
            providerStripePaymentSetting?.charges_enabled ? "text-success" : "text-danger"
          }
        >
          {providerStripePaymentSetting?.charges_enabled ? "✅ Yes" : "❌ No"}
        </span>
      </li>
      <li>
        2. Details Submitted:{" "}
        <span
          className={
            providerStripePaymentSetting?.details_submitted ? "text-success" : "text-danger"
          }
        >
          {providerStripePaymentSetting?.details_submitted ? "✅ Yes" : "❌ No"}
        </span>
      </li>
      <li>
        3. Payouts Enabled:{" "}
        <span
          className={
            providerStripePaymentSetting?.payouts_enabled ? "text-success" : "text-danger"
          }
        >
          {providerStripePaymentSetting?.payouts_enabled ? "✅ Yes" : "❌ No"}
        </span>
      </li>
    </ul>
  </div>
)}



          <div className="table-responsive">
            {loading ? (
              <p>Loading services...</p>
            ) : serviceList.length === 0 ? (
              <p>No services found.</p>
            ) : (
            <table className="table table-striped table-bordered align-middle" id="servicesTable">
              <thead>
                <tr>
                  <th className="font-weight-semibold" onClick={() => handleSort("service_type")}>Service Type <span className="d-grid table-grad"><i className="fa fa-sort-asc sort-icon"></i><i className="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                  <th className="font-weight-semibold" onClick={() => handleSort("service_name")}>Service Name <span className="d-grid table-grad"><i className="fa fa-sort-asc sort-icon"></i><i className="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                  <th className="font-weight-semibold" onClick={() => handleSort("duration")}>Duration <span className="d-grid table-grad"><i className="fa fa-sort-asc sort-icon"></i><i className="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                  <th className="font-weight-semibold" onClick={() => handleSort("charge_per_session")}>Charge Per Session <span className="d-grid table-grad"><i className="fa fa-sort-asc sort-icon"></i><i className="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                  <th className="font-weight-semibold" onClick={() => handleSort("charge_per_month")}>Charge Per Month <span className="d-grid table-grad"><i className="fa fa-sort-asc sort-icon"></i><i className="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                  <th className="font-weight-semibold">Actions</th>
                </tr>
              </thead>
              <tbody>
                {sortedData.map((service, index) => (
                  <tr key={service.id || index}>
                  <td>{service.issueType?.issue_type || "—"}</td>
                  <td>{service.service_name}</td>
                  <td>{service.duration}</td>
                  <td>{service.amount_per_session}</td>
                  <td>{service.amount}</td>
                  <td>
                    <button
                      className="btn text-primary p-1"
                      onClick={() => handleEditClick(service)}
                    >
                      <i className="fa fa-pencil font-size-20"></i>
                    </button>
                    <button
                      className="btn btn-md text-danger me-1 p-1"                      
                      onClick={() => handleDeleteClick(service)}
                    >
                      <i className="fa fa-trash font-size-20"></i>
                    </button>
                  </td>
                </tr>
                ))}
              </tbody>
          </table>
           )}
        </div>
        <>
        
        <div
          className={`modal fade ${showModal ? "show" : ""}`}
          style={{ display: showModal ? "block" : "none" }}
          tabIndex="-1"
          aria-labelledby="editServiceModalLabel"
          aria-hidden={!showModal}
        >
        <div className="modal-dialog modal-dialog-centered modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="font-weight-bold text-primary font-size-24 line-hight-2 montserrat d-flex" id="editServiceModalLabel">
                {modalMode === "edit" ? "Edit Service" : "Add Service"}
              </h5>

              <button
                type="button"
                className="btn-close"
                onClick={handleCloseModal}
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              {selectedService ? (
                <form>
                  <div className="row g-3">
                  <div className="col-sm-6">
                    <label htmlFor="serviceType" className="form-label text-primary mb-1 font-weight-semibold required">
                      Service Type:
                    </label>
                    <select
                      name="service_type"
                      className="form-control"
                      value={selectedService.service_type}
                      onChange={handleChange}
                    >
                      <option value="">Select Service Type</option>
                      {serviceTypes.map((type) => (
                        <option key={type.id} value={type.id}>
                          {type.issue_type}
                        </option>
                      ))}
                    </select>

                  </div>
                  <div className="col-sm-6">
                    <label htmlFor="serviceName" className="form-label text-primary mb-1 font-weight-semibold required">
                      Service Name:
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="service_name"
                      value={selectedService.service_name}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-sm-6">
                    <label htmlFor="duration" className="form-label text-primary mb-1 font-weight-semibold required">
                      Duration (hr):
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      name="duration"
                      value={selectedService.duration}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-sm-6">
                    <label htmlFor="duration" className="form-label text-primary mb-1 font-weight-semibold">
                      Charge Per Hour:
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      name="amount_per_session"
                      value={selectedService.amount_per_session}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-sm-6">
                    <p className="form-label text-primary mb-1 font-weight-semibold">Enrollment Age:</p>
                    <div className="row">
                      <div className="col-sm-6">
                        <input
                          type="number"
                          className="form-control"
                          name="from_age"
                          placeholder="From"
                          value={selectedService.from_age}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="col-sm-6">
                        <input
                          type="number"
                          className="form-control"
                          id="to_age"
                          name="to_age"
                          placeholder="To"
                          value={selectedService.to_age}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <label className="form-label text-primary mb-1 font-weight-semibold">
                      Meals:
                    </label>
                    <div className="d-flex gap-3">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          name="meals"
                          value="breakfast"
                          checked={selectedService.meals?.includes("breakfast")}
                          onChange={handleChange}
                        />
                        <label className="form-check-label" htmlFor="chargeHour">
                          Breakfast
                        </label>
                      </div>

                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          name="meals"
                          value="lunch"
                          checked={selectedService.meals?.includes("lunch")}
                          onChange={handleChange}
                        />
                        <label className="form-check-label" htmlFor="chargeSession">
                          Lunch
                        </label>
                      </div>

                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          name="meals"
                          value="dinner"
                          checked={selectedService.meals?.includes("dinner")}
                          onChange={handleChange}
                        />
                        <label className="form-check-label" htmlFor="chargeMonth">
                          Dinner
                        </label>
                      </div>
                    </div>
                  </div>

                  <div>
                    {/* Languages input */}
                    <div className="row">
                      <div className="col-sm-6">
                        <label className="form-label text-primary mb-1 font-weight-semibold">Languages:</label>
                        <div className="d-flex flex-wrap gap-2 border rounded p-2 w-100">
                          {(selectedService.language_support || []).map((tagObj, index) => (
                            <span key={index} className="badge bg-primary d-flex align-items-center">
                              {tagObj.value}
                              <button
                                type="button"
                                className="btn-close btn-close-white btn-sm ms-2"
                                aria-label={`Remove language ${tagObj.value}`}
                                onClick={() => removeServiceTag(index, "language_support")}
                              />
                            </span>
                          ))}
                          <input
                            type="text"
                            value={languageInput}
                            onChange={(e) => setLanguageInput(e.target.value)}
                            onKeyDown={(e) =>
                              handleKeyDownServiceTag(e, languageInput, setLanguageInput, "language_support")
                            }
                            placeholder="Add languages"
                            className="form-control border-0 flex-grow-1"
                            style={{ minWidth: "80px", outline: "none", flex: "1" }}
                          />
                        </div>
                      </div>


                      <div className="col-sm-6">
                        <label className="form-label text-primary mb-1 font-weight-semibold">Additional Fields:</label>
                        <div className="d-flex flex-wrap gap-2 border rounded p-2 w-100">
                          {(selectedService.additional_tags || []).map((tagObj, index) => (
                            <span key={index} className="badge bg-primary d-flex align-items-center">
                              {tagObj.value}
                              <button
                                type="button"
                                className="btn-close btn-close-white btn-sm ms-2"
                                aria-label={`Remove field ${tagObj.value}`}
                                onClick={() => removeServiceTag(index, "additional_tags")}
                              />
                            </span>
                          ))}
                          <input
                            type="text"
                            className="form-control border-0 flex-grow-1"
                            value={fieldInput}
                            onChange={(e) => setFieldInput(e.target.value)}
                            onKeyDown={(e) =>
                              handleKeyDownServiceTag(e, fieldInput, setFieldInput, "additional_tags")
                            }
                            placeholder="Add fields"
                            style={{ minWidth: "80px", outline: "none", flex: "1" }}
                          />
                        </div>
                      </div>

                  </div>
                </div>
                <div className="col-sm-12">
                    <label className="form-label text-primary mb-1 font-weight-semibold">
                      Service Mode:
                    </label>
                    <div className="d-flex gap-3">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          name="service_mode"
                           value="online"
                           checked={selectedService.service_mode?.includes("online")}
                          onChange={handleChange}
                          
                        />
                        <label className="form-check-label" htmlFor="chargeHour">
                          Online
                        </label>
                      </div>

                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          name="service_mode"
                          value="offline"
                           checked={selectedService.service_mode?.includes("offline")}
                          onChange={handleChange}
                          
                        />
                        <label className="form-check-label" htmlFor="chargeSession">
                          Offline
                        </label>
                      </div>
                    </div>
                  </div>
                    <div >
                      <QuillEditor
                          value={selectedService?.service_description || ''}
                          onChange={(val) =>
                            setSelectedService((prev) => ({
                              ...prev,
                              service_description: val,
                            }))
                          }
                        />
                  </div>
                  <div className="modal-header">
              <h5 className="font-weight-bold text-primary font-size-24 line-hight-2 montserrat d-flex">
                Subscription Details
              </h5>
            </div>
            <div className="col-sm-6">
                    <label htmlFor="daily_hours" className="form-label text-primary mb-1 font-weight-semibold">
                      Duration (In Days):
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      name="duration_in_days"
                      value={selectedService.duration_in_days}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-sm-6">
                    <label htmlFor="daily_hours" className="form-label text-primary mb-1 font-weight-semibold">
                      Daily Hours:
                    </label>
                    <input
                      type="time"
                      className="form-control"
                      name="daily_hours"
                      value={selectedService.daily_hours}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-sm-6">
                    <label htmlFor="amount" className="form-label text-primary mb-1 font-weight-semibold">
                      Charge Per Month:
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      name="amount"
                      value={selectedService.amount}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-sm-6">
                    <label htmlFor="charge_per_week" className="form-label text-primary mb-1 font-weight-semibold">
                      Charge Per Week
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      name="charge_per_week"
                      value={selectedService.charge_per_week}
                      onChange={handleChange}
                    />
                  </div>
                  </div>
                </form>
              ) : (
                <p>No service selected.</p>
              )}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-danger font-weight-medium font-size-16 text-capitalize px-4 rounded m-1"
                onClick={handleCloseModal}
              >
                Close
              </button>
            <button
              type="button"
              className="btn btn-custom-primary font-weight-medium font-size-16 text-capitalize px-4 rounded m-1"
              onClick={modalMode === "edit" ? handleSaveChanges : handleAddService}
            >
              {modalMode === "edit" ? "Save changes" : "Add Service"}
            </button>
            </div>
          </div>
        </div>
      </div>
      {confirmDelete && (
      <div className="modal show" style={{ display: "block" }}>
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="font-weight-bold text-primary font-size-24 line-hight-2 montserrat d-flex">Delete Service</h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => setConfirmDelete(false)}
              ></button>
            </div>
            <div className="modal-body">
              Are you sure you want to delete{" "}
              <strong>{serviceToDelete?.service_name}</strong>?
            </div>
            <div className="modal-footer">
              <button
                className="btn btn-secondary font-weight-medium font-size-16 text-capitalize px-4 rounded m-1"
                onClick={() => setConfirmDelete(false)}
              >
                Cancel
              </button>
              <button className="btn btn-danger font-weight-medium font-size-16 text-capitalize px-4 rounded m-1" onClick={confirmDeleteService}>
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
    )}
      </>
        
      </div>
    </div>
  </>
);

};

export default ProviderPanelService;
